import LinkifiedText from './LinkifiedText'

export default LinkifiedText



// WEBPACK FOOTER //
// ./src/components/LinkifiedText/index.js